import { logger as E } from "../../shared-lib/index.js";
import { BANNERS_DISABLED_MESSAGE as v, BRAZE_MUST_BE_INITIALIZED_ERROR as w } from "../common/constants.js";
import r, { OPTIONS as z } from "../managers/braze-instance.js";
import { isArray as D } from "../util/code-utils.js";
import { isValidBannerPlacementId as R } from "../util/validation-utils.js";
import i from "./banner-provider-factory.js";
export function requestBannersRefresh(e, t, n) {
  if (!r.rr()) return void E.warn(w);
  var o = r.l();
  if (!o) return;
  if (!D(e) || 0 === e.length) return void E.warn("placementIds should be a non-empty array.");
  if (!r.ee(z.re)) return void E.error("Banners are disabled. Use the 'allowUserSuppliedJavascript' option for braze.initialize to enable these messages.");
  var s = i.o();
  if (!1 === o.Dt() && E.error(v), !s.k()) return void o.P(function () {
    requestBannersRefresh(e, t, n);
  });
  var a = o.te();
  e.length > a && (E.warn("Number of placement IDs requested exceeds the max allowed. Trimming placementIds array from length ".concat(e.length, " to ").concat(a, " (max allowed).")), e = e.slice(0, a)), 0 !== (e = e.filter(function (e) {
    return !!R(e) || (E.warn("Placement ID should be a valid utf8 string with no whitespaces, filtering out: ".concat(e)), !1);
  })).length && (E.info("Requesting banners for placement IDs: ".concat(JSON.stringify(e))), s.M(e, t, n));
}